import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class CustomPaginatorIntl implements MatPaginatorIntl {
	public readonly changes = new Subject<void>();

	public readonly firstPageLabel = 'Erste Seite'; // `First page`
	public readonly itemsPerPageLabel = 'Items per Seite:'; // `Items per page:`
	public readonly lastPageLabel = 'Letzte Seite'; // `Last page`

	public readonly nextPageLabel = 'Nächste Seite'; // 'Next page'
	public readonly previousPageLabel = 'Vorherige Seite'; // 'Previous page'

	public getRangeLabel(page: number, pageSize: number, length: number): string {
		if (length === 0) {
			return `Seite 1 von 1`; // Page 1 of 1
		}
		const amountPages = Math.ceil(length / pageSize);
		return `Seite ${page + 1} von ${amountPages}`; // Page {{current}} of {{total}}
	}
}
